var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "110px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "项目名称", prop: "activityTitle" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          type: "text",
                          clearable: "",
                          placeholder: "请输入项目名称",
                          disabled: _vm.isDetail
                        },
                        model: {
                          value: _vm.childData.activityTitle,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "activityTitle", $$v)
                          },
                          expression: "childData.activityTitle"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "项目类型", prop: "activityId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "400px" },
                          attrs: {
                            disabled: true,
                            clearable: "",
                            filterable: "",
                            placeholder: "请选择项目类型"
                          },
                          on: { change: _vm.changeCharge },
                          model: {
                            value: _vm.childData.activityId,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "activityId", $$v)
                            },
                            expression: "childData.activityId"
                          }
                        },
                        _vm._l(_vm.activeTypeOption, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.activityTypeName,
                              value: item.id,
                              disabled: true
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "活动地点", prop: "activityLocation" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          type: "text",
                          clearable: "",
                          placeholder: "请输入活动地点",
                          disabled: _vm.isDetail
                        },
                        model: {
                          value: _vm.childData.activityLocation,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "activityLocation", $$v)
                          },
                          expression: "childData.activityLocation"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "计划报名人数",
                        prop: "activityPlannedEnrollment"
                      }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          disabled: _vm.isDetail,
                          precision: 0,
                          step: 1,
                          min: 1,
                          max: 9999999
                        },
                        model: {
                          value: _vm.childData.activityPlannedEnrollment,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.childData,
                              "activityPlannedEnrollment",
                              $$v
                            )
                          },
                          expression: "childData.activityPlannedEnrollment"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          !_vm.isBuildParty && !_vm.isDashboard
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "报名时间",
                            prop: "registrationDates"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              disabled: _vm.isDetail,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              type: "datetimerange",
                              "range-separator": "至",
                              "start-placeholder": "报名开始时间",
                              "end-placeholder": "报名结束时间"
                            },
                            on: { change: _vm.handleRegistrationDate },
                            model: {
                              value: _vm.childData.registrationDates,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.childData,
                                  "registrationDates",
                                  $$v
                                )
                              },
                              expression: "childData.registrationDates"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动时间", prop: "activeDates" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              disabled: _vm.isDetail,
                              "value-format": "yyyy-MM-dd",
                              type: "daterange",
                              "range-separator": "至",
                              "start-placeholder": "活动开始时间",
                              "end-placeholder": "活动结束时间"
                            },
                            on: { change: _vm.handleActiveDates },
                            model: {
                              value: _vm.childData.activeDates,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "activeDates", $$v)
                              },
                              expression: "childData.activeDates"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否计费", prop: "isCharge" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "400px" },
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: "请选择是否计费"
                          },
                          model: {
                            value: _vm.childData.isCharge,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "isCharge", $$v)
                            },
                            expression: "childData.isCharge"
                          }
                        },
                        _vm._l(_vm.isChargeOption, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.value,
                              value: item.id,
                              disabled: _vm.isDetail
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序", prop: "actiOrder" } },
                    [
                      _c("el-input-number", {
                        staticClass: "form-item-number",
                        attrs: { disabled: _vm.isDetail, min: 1, max: 99 },
                        model: {
                          value: _vm.childData.actiOrder,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "actiOrder", $$v)
                          },
                          expression: "childData.actiOrder"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "required", attrs: { label: "活动内容" } },
            [
              _c("Tinymce", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isDetail,
                    expression: "!isDetail"
                  }
                ],
                ref: "editor",
                attrs: { menubar: !_vm.isDetail, height: 300 },
                model: {
                  value: _vm.childData.activityOption,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "activityOption", $$v)
                  },
                  expression: "childData.activityOption"
                }
              }),
              _c("Tinymce", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isDetail,
                    expression: "isDetail"
                  }
                ],
                ref: "viewer",
                staticStyle: { width: "580px" },
                attrs: {
                  height: 300,
                  menubar: false,
                  toolbar: _vm.toolbar,
                  readonly: _vm.readonly
                },
                model: {
                  value: _vm.childData.activityOption,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "activityOption", $$v)
                  },
                  expression: "childData.activityOption"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "报名须知", prop: "remark" } },
            [
              _c("el-input", {
                staticStyle: { width: "100%" },
                attrs: {
                  autosize: { minRows: 2, maxRows: 6 },
                  maxlength: "300",
                  "show-word-limit": "",
                  type: "textarea",
                  clearable: "",
                  placeholder: "请输入报名须知",
                  disabled: _vm.isDetail
                },
                model: {
                  value: _vm.childData.remark,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "remark", $$v)
                  },
                  expression: "childData.remark"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动封面", prop: "files" } },
            [
              _c(
                "el-upload",
                {
                  staticClass: "upload-demo",
                  attrs: {
                    "on-exceed": _vm.handleExceed,
                    name: "files",
                    limit: 1,
                    "on-error": _vm.handleError,
                    "on-success": _vm.handleSuccess,
                    action: _vm.uploadUrl,
                    "on-preview": _vm.handlePreview,
                    "on-remove": _vm.handleRemove,
                    "before-remove": _vm.beforeRemove,
                    "before-upload": _vm.beforeUpload,
                    multiple: "",
                    disabled: _vm.isDetail,
                    "file-list": _vm.files
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        disabled: _vm.isDetail
                      }
                    },
                    [_vm._v("点击上传")]
                  )
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.dialogVisible,
                    width: "700px",
                    title: "预览"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisible = $event
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" }
                  })
                ]
              )
            ],
            1
          ),
          _vm.childData.activityId != 4
            ? _c(
                "el-form-item",
                { staticClass: "required", attrs: { label: "收费明细" } },
                [
                  _vm.viewType == 0 && !_vm.isDetail
                    ? _c(
                        "div",
                        { staticClass: "filter-container" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-circle-plus-outline"
                              },
                              on: { click: _vm.handleCreate }
                            },
                            [_vm._v(_vm._s(_vm.$t("button.add")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.childData.changeActivityItemVos,
                        "element-loading-text": "数据正在加载中...",
                        border: "",
                        stripe: "",
                        fit: "",
                        "highlight-current-row": ""
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: _vm.$t("table.id"),
                          width: "50"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "报名内容",
                          "show-overflow-tooltip": "",
                          "min-width": "200px"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.itemName))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3535532340
                        )
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "价格(元)",
                          "min-width": "100px"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.itemPrice))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          710868222
                        )
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "排序",
                          "min-width": "100px"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.itemOrder))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          4025853085
                        )
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "有效期(月)",
                          "min-width": "100px"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.validPeriod))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1045021109
                        )
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "核销次数(次)",
                          "min-width": "100px"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.checkNum))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2087287382
                        )
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "最大报名人数(人)",
                          "min-width": "130px"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.totalNumber))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3462332615
                        )
                      }),
                      _vm.viewType == 0 && !_vm.isDetail
                        ? _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: _vm.$t("table.actions"),
                              "class-name": "small-padding fixed-width",
                              "min-width": "200px"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            plain: "",
                                            icon: "el-icon-edit"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleUpdate(
                                                scope.row,
                                                scope.$index
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("button.edit")))]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "danger",
                                            size: "mini",
                                            plain: "",
                                            icon: "el-icon-delete"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleDelete(
                                                scope.row,
                                                scope.$index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("button.delete"))
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              177457355
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          !_vm.isDetail
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
                [_vm._v(_vm._s(_vm.$t("button.confirm")))]
              )
            : _vm._e(),
          _vm.isAudit
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handPass } },
                [_vm._v("通过")]
              )
            : _vm._e(),
          _vm.isAudit
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handUnPass } },
                [_vm._v("不通过")]
              )
            : _vm._e(),
          (_vm.isDetail || _vm.isAudit) && _vm.childData.activityId == 4
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-setting" },
                  on: {
                    click: function($event) {
                      return _vm.handleConfig(
                        _vm.childData.id,
                        _vm.childData.activityAuditStatus
                      )
                    }
                  }
                },
                [_vm._v("查看场次配置")]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c("addChargeItem", {
            attrs: {
              "key-value": _vm.activityItem,
              "show-dialog": _vm.dialogFormVisible
            },
            on: { handCancle: _vm.handItemCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.titleConfig,
            visible: _vm.dialogPlacePriceFormVisible,
            width: "1200px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogPlacePriceFormVisible = $event
            }
          }
        },
        [
          _c("configList", {
            attrs: {
              "key-value": _vm.id,
              "show-dialog": _vm.dialogPlacePriceFormVisible,
              activityAuditStatus: _vm.activityAuditStatus
            },
            on: { handCancle: _vm.handCancleConfig }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }